import { render, staticRenderFns } from "./ProductImages.vue?vue&type=template&id=e024ac78"
import script from "./ProductImages.ts?vue&type=script&lang=ts&external"
export * from "./ProductImages.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports